import React from 'react';
import { connect } from 'react-redux';
import { CalendarBlank } from 'phosphor-react';
import { withStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import { useRouter } from 'next/router';

import { buttonStyles } from '../../styles/base';
import { fetchShowings } from '../../actions/showing';
import PageBase from '../../components/layout/PageBase';
import LogoLoader from '../../components/utility/LogoLoader';
import SignupAlertCard from '../../components/utility/SignupAlertCard';
import ShowingsCalendar from '../../components/utility/ShowingsCalendar';
import ShowingsColumn from '../../components/utility/ShowingsCalendar/ShowingsColumn';
import NoResults from '../../components/utility/NoResults';

interface Props {
  classes: any;
  getShowings: Function;
  feedSearch: any;
  showings: any;
  showingsLoading: boolean;
  token: string | undefined;
}

export function Tours({
  classes,
  getShowings,
  feedSearch,
  showings,
  showingsLoading,
  token,
}: Props) {
  const router = useRouter();

  React.useEffect(() => {
    if (token) {
      getShowings(token);
    }
  }, [token]);

  const handleSearchListings = React.useCallback(() => {
    router.push({
      pathname: '/search',
      query: {
        location: feedSearch.location,
        filters: JSON.stringify(feedSearch),
      },
    });
  }, [feedSearch]);

  if (!token) {
    return (
      <PageBase
        title="Torii Homes: Schedule a home tour"
        overrideRemarks="Easily schedule home tours, attend open houses, and manage your showings all in one place."
      >
        <div className={`page-container col-xs-12 row center-xs`}>
          <SignupAlertCard
            icon={<CalendarBlank size={30} color="#636363" weight="fill" />}
            subtext="Sign up to schedule home tours, attend open houses, and manage your showings."
          />
        </div>
      </PageBase>
    );
  }

  return (
    <PageBase
      title="Torii Homes: Schedule a home tour"
      overrideRemarks="Easily schedule home tours, attend open houses, and manage your showings all in one place."
    >
      <div className={`col-xs-12 page-container`}>
        <div className="showings-container">
          <h2 className="page-title">Tours</h2>
          {showingsLoading ? (
            <LogoLoader imageProps={{ height: 150, width: 150 }} />
          ) : showings.length > 0 ? (
            <div className="showings-content">
              <ShowingsColumn showings={showings} />
              <div style={{ margin: '20px 0' }}>
                <ShowingsCalendar disableSelect />
              </div>
            </div>
          ) : (
            <div className="center-xs">
              <NoResults
                emptyText={`Looks like you don't have any home tours yet.\nClick the "Tour" tab on any listing to schedule a tour or attend an open house.`}
              />
              <Button
                className={classes.buttonMediumGreen}
                style={{ marginTop: 20, borderRadius: 20 }}
                onClick={handleSearchListings}
              >
                Browse Listings
              </Button>
            </div>
          )}
        </div>
      </div>
    </PageBase>
  );
}

const mapStateToProps = (state: any) => ({
  feedSearch: state.feed.feedSearch,
  showings: state.showings.showings,
  showingsLoading: state.showings.showingsLoading,
  token: state.auth.token,
});

const mapDispatchToProps = (dispatch: any) => ({
  getShowings(token: string) {
    dispatch(fetchShowings(token));
  },
});

export default withStyles(buttonStyles)(
  connect(mapStateToProps, mapDispatchToProps)(Tours),
);
